module.exports = __webpack_public_path__ + "media/img/pages/companies/ems-5bd0fc4057e5b8cf2d8e8cb8e611cd58.png";